var e={staging:process.env.NEXT_PUBLIC_MOBIUS_API_URL||"https://api.staging.mobius.highereducation.com",prod:process.env.NEXT_PUBLIC_MOBIUS_API_URL||"https://api.mobius.highereducation.com",identityToken:"11a86905-d823-4fd9-921e-662d9937cb8e"};export{e as m};
//# sourceMappingURL=index16.js.map
